import { useState } from "react";

interface Props {
  onClick: () => void;
}

export function InspectButton({ onClick }: Props) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      className="w-full py-[9px] text-[13px] flex items-center gap-2 px-3 cursor-pointer outline-none rounded-[6px]"
      style={
        hovered
          ? {
              background: "linear-gradient(180deg, #0f2040 0%, #071525 100%)",
              border: "1px solid #137fe3",
              color: "#137fe3",
              transition: "color 150ms ease, background 150ms ease, border-color 150ms ease",
            }
          : {
              background: "radial-gradient(ellipse at center, #161616 0%, #0b0b0b 100%)",
              border: "1px solid rgba(19,127,227,0.25)",
              color: "#137fe3",
              transition: "color 150ms ease, background 150ms ease, border-color 150ms ease",
            }
      }
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      Inspect Item
    </button>
  );
}
